export default {
  "2006": [
    "Algester",
    "Aspley",
    "Bancroft",
    "Barron River",
    "Bonney",
    "Broadwater",
    "Buderim",
    "Bulimba",
    "Bundaberg",
    "Bundamba",
    "Burdekin",
    "Burleigh",
    "Burnett",
    "Cairns",
    "Callide",
    "Caloundra",
    "Capalaba",
    "Chatsworth",
    "Clayfield",
    "Condamine",
    "Cook",
    "Coomera",
    "Cooper",
    "Currumbin",
    "Everton",
    "Ferny Grove",
    "Gaven",
    "Gladstone",
    "Glass House",
    "Greenslopes",
    "Gregory",
    "Gympie",
    "Hervey Bay",
    "Hill",
    "Hinchinbrook",
    "Inala",
    "Ipswich West",
    "Ipswich",
    "Jordan",
    "Kawana",
    "Keppel",
    "Kurwongbah",
    "Lockyer",
    "Logan",
    "Lytton",
    "Macalister",
    "Mackay",
    "Maiwar",
    "Mansfield",
    "Maroochydore",
    "Maryborough",
    "McConnel",
    "Mermaid Beach",
    "Miller",
    "Mirani",
    "Moggill",
    "Morayfield",
    "Mount Ommaney",
    "Mudgeeraba",
    "Mulgrave",
    "Mundingburra",
    "Murrumba",
    "Nanango",
    "Nicklin",
    "Ninderry",
    "Noosa",
    "Nudgee",
    "Oodgeroo",
    "Pine Rivers",
    "Pumicestone",
    "Redcliffe",
    "Redlands",
    "Rockhampton",
    "Sandgate",
    "Scenic Rim",
    "South Brisbane",
    "Southern Downs",
    "Southport",
    "Springwood",
    "Stafford",
    "Stretton",
    "Surfers Paradise",
    "Theodore",
    "Thuringowa",
    "Toohey",
    "Toowoomba North",
    "Toowoomba South",
    "Townsville",
    "Traeger",
    "Warrego",
    "Waterford",
    "Whitsunday",
    "Woodridge"
  ],
  "2011": [
    "Albert",
    "Algester",
    "Ashgrove",
    "Aspley",
    "Barron River",
    "Beaudesert",
    "Brisbane Central",
    "Broadwater",
    "Buderim",
    "Bulimba",
    "Bundaberg",
    "Bundamba",
    "Burdekin",
    "Burleigh",
    "Burnett",
    "Cairns",
    "Callide",
    "Caloundra",
    "Capalaba",
    "Chatsworth",
    "Clayfield",
    "Cleveland",
    "Condamine",
    "Cook",
    "Coomera",
    "Currumbin",
    "Dalrymple",
    "Everton",
    "Ferny Grove",
    "Gaven",
    "Gladstone",
    "Glass House",
    "Greenslopes",
    "Gregory",
    "Gympie",
    "Hervey Bay",
    "Hinchinbrook",
    "Inala",
    "Indooroopilly",
    "Ipswich",
    "Ipswich West",
    "Kallangur",
    "Kawana",
    "Keppel",
    "Lockyer",
    "Logan",
    "Lytton",
    "Mackay",
    "Mansfield",
    "Maroochydore",
    "Maryborough",
    "Mermaid Beach",
    "Migratory - Offshore - Shipping (Qld)",
    "Mirani",
    "Moggill",
    "Morayfield",
    "Mount Coot-tha",
    "Mount Isa",
    "Mount Ommaney",
    "Mudgeeraba",
    "Mulgrave",
    "Mundingburra",
    "Murrumba",
    "Nanango",
    "Nicklin",
    "Noosa",
    // "No usual address (Qld)",
    "Nudgee",
    "Pine Rivers",
    "Pumicestone",
    "Redcliffe",
    "Redlands",
    "Rockhampton",
    "Sandgate",
    "South Brisbane",
    "Southern Downs",
    "Southport",
    "Springwood",
    "Stafford",
    "Stretton",
    "Sunnybank",
    "Surfers Paradise",
    "Thuringowa",
    "Toowoomba North",
    "Toowoomba South",
    "Townsville",
    "Warrego",
    "Waterford",
    "Whitsunday",
    "Woodridge",
    "Yeerongpilly"
  ],
  "2016": [
    "Algester",
    "Aspley",
    "Bancroft",
    "Barron River",
    "Bonney",
    "Broadwater",
    "Buderim",
    "Bulimba",
    "Bundaberg",
    "Bundamba",
    "Burdekin",
    "Burleigh",
    "Burnett",
    "Cairns",
    "Callide",
    "Caloundra",
    "Capalaba",
    "Chatsworth",
    "Clayfield",
    "Condamine",
    "Cook",
    "Coomera",
    "Cooper",
    "Currumbin",
    "Everton",
    "Ferny Grove",
    "Gaven",
    "Gladstone",
    "Glass House",
    "Greenslopes",
    "Gregory",
    "Gympie",
    "Hervey Bay",
    "Hill",
    "Hinchinbrook",
    "Inala",
    "Ipswich West",
    "Ipswich",
    "Jordan",
    "Kawana",
    "Keppel",
    "Kurwongbah",
    "Lockyer",
    "Logan",
    "Lytton",
    "Macalister",
    "Mackay",
    "Maiwar",
    "Mansfield",
    "Maroochydore",
    "Maryborough",
    "McConnel",
    "Mermaid Beach",
    "Miller",
    "Mirani",
    "Moggill",
    "Morayfield",
    "Mount Ommaney",
    "Mudgeeraba",
    "Mulgrave",
    "Mundingburra",
    "Murrumba",
    "Nanango",
    "Nicklin",
    "Ninderry",
    "Noosa",
    "Nudgee",
    "Oodgeroo",
    "Pine Rivers",
    "Pumicestone",
    "Redcliffe",
    "Redlands",
    "Rockhampton",
    "Sandgate",
    "Scenic Rim",
    "South Brisbane",
    "Southern Downs",
    "Southport",
    "Springwood",
    "Stafford",
    "Stretton",
    "Surfers Paradise",
    "Theodore",
    "Thuringowa",
    "Toohey",
    "Toowoomba North",
    "Toowoomba South",
    "Townsville",
    "Traeger",
    "Warrego",
    "Waterford",
    "Whitsunday",
    "Woodridge"
  ],
  "2021": [
    "Algester",
    "Aspley",
    "Bancroft",
    "Barron River",
    "Bonney",
    "Broadwater",
    "Buderim",
    "Bulimba",
    "Bundaberg",
    "Bundamba",
    "Burdekin",
    "Burleigh",
    "Burnett",
    "Cairns",
    "Callide",
    "Caloundra",
    "Capalaba",
    "Chatsworth",
    "Clayfield",
    "Condamine",
    "Cook",
    "Coomera",
    "Cooper",
    "Currumbin",
    "Everton",
    "Ferny Grove",
    "Gaven",
    "Gladstone",
    "Glass House",
    "Greenslopes",
    "Gregory",
    "Gympie",
    "Hervey Bay",
    "Hill",
    "Hinchinbrook",
    "Inala",
    "Ipswich West",
    "Ipswich",
    "Jordan",
    "Kawana",
    "Keppel",
    "Kurwongbah",
    "Lockyer",
    "Logan",
    "Lytton",
    "Macalister",
    "Mackay",
    "Maiwar",
    "Mansfield",
    "Maroochydore",
    "Maryborough",
    "McConnel",
    "Mermaid Beach",
    "Miller",
    "Mirani",
    "Moggill",
    "Morayfield",
    "Mount Ommaney",
    "Mudgeeraba",
    "Mulgrave",
    "Mundingburra",
    "Murrumba",
    "Nanango",
    "Nicklin",
    "Ninderry",
    "Noosa",
    "Nudgee",
    "Oodgeroo",
    "Pine Rivers",
    "Pumicestone",
    "Redcliffe",
    "Redlands",
    "Rockhampton",
    "Sandgate",
    "Scenic Rim",
    "South Brisbane",
    "Southern Downs",
    "Southport",
    "Springwood",
    "Stafford",
    "Stretton",
    "Surfers Paradise",
    "Theodore",
    "Thuringowa",
    "Toohey",
    "Toowoomba North",
    "Toowoomba South",
    "Townsville",
    "Traeger",
    "Warrego",
    "Waterford",
    "Whitsunday",
    "Woodridge"
  ]
};



// WEBPACK FOOTER //
// ../data/qld/electoral_districts.js